<template lang="pug">
.footerAgreementComponent(:class="[`_${lineColor}`]")
  a.link(href='https://prosv.ru/pages/privacy-policy.html' target="_blank") Пользовательское соглашение
  span {{' и '}}
  a.link(href='https://prosv.ru/pages/third-party-organizations.html' target="_blank") Персональные данные
</template>

<script>
export default {
  props: {
    // light | dark
    lineColor: {
      type: String,
      default: 'dark'
    }
  }
}
</script>

<style lang="sass" scoped>
.footerAgreementComponent
  > .link
    position: relative
    cursor: pointer
    display: inline-block
    &::after
      content: ''
      position: absolute
      bottom: -1px
      left: 0
      width: 100%
      height: 1px
      background-color: $cBlue
  &._light
    > .link
      &:after
        background-color: $cBlue
</style>
